module.exports = __webpack_public_path__ + "static/press-banner2-9878944cf22261460c162d4196194fa3.png";